import { create } from 'zustand';
import type { MapMode, LayerId, LayerVisibility, AircraftState } from '../types/mapEngine';
import { LAYER_PRESETS } from '../components/map-engine/modes/layerPresets';

const DARK_STYLE = 'mapbox://styles/mapbox/empty-v9';

interface MapState {
  mode: MapMode;
  layerVisibility: LayerVisibility;
  aircraft: AircraftState[];
  icaoCode: string;
  aipRasterOpacity: number;
  baseStyle: string;

  setMode: (mode: MapMode) => void;
  setLayerVisibility: (id: LayerId, visible: boolean) => void;
  resetLayersToPreset: (mode: MapMode) => void;
  setAircraft: (aircraft: AircraftState[]) => void;
  updateAircraftPosition: (id: string, position: [number, number], heading: number) => void;
  setIcaoCode: (icao: string) => void;
  setAipRasterOpacity: (opacity: number) => void;
  setBaseStyle: (style: string) => void;
}

export const useMapStore = create<MapState>((set) => ({
  mode: 'fts-conops',
  layerVisibility: LAYER_PRESETS['fts-conops'],
  aircraft: [],
  icaoCode: 'MPTO',
  aipRasterOpacity: 0.75,
  baseStyle: DARK_STYLE,

  setMode: (mode) =>
    set({ mode, layerVisibility: LAYER_PRESETS[mode] }),

  setLayerVisibility: (id, visible) =>
    set((s) => ({ layerVisibility: { ...s.layerVisibility, [id]: visible } })),

  resetLayersToPreset: (mode) =>
    set({ layerVisibility: LAYER_PRESETS[mode] }),

  setAircraft: (aircraft) => set({ aircraft }),

  updateAircraftPosition: (id, position, heading) =>
    set((s) => ({
      aircraft: s.aircraft.map((a) =>
        a.id === id ? { ...a, position, heading } : a
      ),
    })),

  setIcaoCode: (icaoCode) => set({ icaoCode }),

  setAipRasterOpacity: (aipRasterOpacity) => set({ aipRasterOpacity }),
  setBaseStyle: (baseStyle) => set({ baseStyle }),
}));
